import Api from 'common/api'

import types from './types'

const USER_URL = '/api/user'
const AVATAR_URL = '/api/user/avatar'
const dispatchedFetchUser = (dispatch) => {
  dispatch({
    type: types.FETCH_USER_START,
  })
  return Api.get(USER_URL)
    .then((user) => {
      dispatch({
        type: types.FETCH_USER_SUCCESS,
        payload: user,
      })
    })
    .catch(() => {
      dispatch({
        type: types.FETCH_USER_FAILURE,
      })
    })
}
const fetchUser = () => {
  return dispatchedFetchUser
}
const updateAvatar = (fileKey) => {
  return (dispatch) => {
    const avatarInfo = {
      Bucket: window.FILE_STACK_BUCKET,
      Object: fileKey,
    }
    dispatch({
      type: types.UPDATE_AVATAR_START,
    })
    return Api.put(AVATAR_URL, avatarInfo)
      .then(() => {
        dispatch({
          type: types.UPDATE_AVATAR_SUCCESS,
        })
        return dispatchedFetchUser(dispatch)
      })
      .catch(() => {
        dispatch({
          type: types.UPDATE_AVATAR_FAILURE,
        })
        return Promise.reject()
      })
  }
}
const updateUser = (newUser) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_USER_START,
    })
    return Api.put(USER_URL, newUser)
      .then(() => {
        dispatch({
          type: types.UPDATE_USER_SUCCESS,
        })
        return dispatchedFetchUser(dispatch)
      })
      .catch(() => {
        dispatch({
          type: types.UPDATE_USER_FAILURE,
        })
        return Promise.reject()
      })
  }
}

const actions = {
  fetchUser,
  updateUser,
  updateAvatar,
}

export default actions
